export const defaultMenuData = {
    entreeA: '',
    platA: '',
    laitageA: '',
    dessertA: '',
    entreeB: '',
    platB: '',
    laitageB: '',
    dessertB: '',
    entreeD: '',
    platD: '',
    laitageD: '',
    dessertD: '',
    entreeH: '',
    platH: '',
    laitageH: '',
    dessertH: '',
    entreeSS: '',
    platSS: '',
    laitageSS: '',
    dessertSS: '',
    entreeSV: '',
    platSV: '',
    laitageSV: '',
    dessertSV: '',
    entreeSP: '',
    platSP: '',
    laitageSP: '',
    dessertSP: '',
    potage: '',
    diner: '',
    brick: '',
}